import { defineComponent, computed } from "vue";
export default defineComponent({
    name: "PtHightlightText",
    inheritAttrs: false,
    props: {
        text: {
            type: String,
            required: true
        },
        color: {
            type: String
        },
        keyword: {
            type: String,
            required: true
        }
    },
    setup: function setup(props) {
        var html = computed(function() {
            if (!props.keyword) return props.text;
            return props.text.replace(new RegExp(props.keyword, "gi"), function(match) {
                return '<span style="color: '.concat(props.color, '">').concat(match, "</span>");
            });
        });
        return {
            html: html
        };
    }
});
